/**
 * @file 定义路由匹配，渲染对应的 UI 组件
 * @author chris<wfsr@foxmail.com>
 */
import React from 'react';
import {Switch} from 'react-router-dom';
// @ts-ignore
import EnhancedRoute from '~/component/EnhancedRoute';
// @ts-ignore
import BasicLayout from '~/layout/BasicLayout';
import routes from './route.config';
// @ts-ignore
import {joinPath} from './utils/url';

const layouts: any = {
    BasicLayout,
};

/**
 * 将路由配置格式化：每个路由中的routes对象下的路由打平
 *
 * @param {Array} routes 路由配置数组
 * @param {Object=} superRoute 上级路由对象
 * @return {Array}
 */
const formatRoutes = (routes: any, superRoute?: any) => {
    const {path = ''} = superRoute || {};

    return routes.reduce((newRoutes: any, route: any) => {
        const {routes: children, ...rest} = route;

        const {path: subPath = ''} = rest;
        rest.path = joinPath(path, subPath);
        if (superRoute) {
            rest.super = superRoute;
        }

        newRoutes.push(rest);

        if (children?.length) {
            newRoutes.push(...formatRoutes(children, rest));
        }

        return newRoutes;
    }, []);
};

export default function Routes() {

    return (
        <Switch>
            {formatRoutes(routes).map(
                (route: any) => {
                    const {
                        path = '/',
                        layout = 'BasicLayout',
                        exact = true,
                        redirect = ''
                    } = route;

                    return (
                        <EnhancedRoute
                            exact={exact}
                            key={path}
                            path={path}
                            redirect={redirect}
                            layout={layouts[layout]}
                            routeConfig={route}
                        />
                    );
                }
            )}
        </Switch>
    );
}
